import React, { useContext } from 'react';
import { LaptopOutlined, NotificationOutlined, RightOutlined, UserOutlined } from '@ant-design/icons';
import { Breadcrumb, Button, Layout, Menu, Switch, theme } from 'antd';
import { Context } from '../context';
import { useParams, useNavigate } from 'react-router-dom';
import { Footer } from './Footer';
import { Subscribe } from './Subscribe';
import { SubscribeSalesforce } from './SubscribeSalesforce';
const { Header, Content, Sider } = Layout;




export const MainLayout = ({ children, page }) => {
  const navigate = useNavigate();

  const context = useContext(Context);
  const { alumni, project } = useParams();
  const alumniHandle = alumni ? alumni.replace('@', '') : null;
  const alumniData = alumniHandle ? context.x.getAlumniByHandle(alumniHandle) : null;

  const projectData = project ? context.x.getProjectById(project) : null;

  const items1 = alumniData ? [
    {
      key: 2,
      label: `${alumniData.name}`,
      onClick: () => navigate(`/@${alumniHandle}`),
    },
    // projectData && {
    //   key: 3,
    //   label: `${projectData.name}`,
    //   onClick: () => navigate(`/@${alumniHandle}/${projectData._id}`),
    // },
  ] : [];

  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();
  return (<>

    <Layout className='b content' style={{ position: 'relative' }}>
      <div
        style={{
          padding: '16px 0px 16px 0',
          backgroundColor: '#00000051',
          backdropFilter: 'blur(10px)',
          position: 'sticky',
          top: 0,
          zIndex: 1000,
        }}
        className="_f _fm _f100  _fgapx1 _fgapy04 _fwrap "
      >


        <div className="global-logo _fc _fgapx1 _fgapy04 _fwrap"
          style={{
            color: '#fff',
          }}
          onClick={() => {
            navigate('/')
            context.state.setFilterCategories()
          }}
        >

          <svg xmlns="http://www.w3.org/2000/svg" width={181} height={20}>
            <path d="M163.5.499c0-.277.245-.499.514-.499h.678l11.261 12.278h.029V.805c0-.277.216-.528.514-.528h2.49a.54.54 0 0 1 .514.528v18.696c0 .277-.243.499-.514.499h-.649L167.02 7.249h-.029v11.946c0 .277-.216.528-.514.528h-2.463c-.269 0-.514-.25-.514-.528V.499zm-23.015 15.889c3.506 0 6.398-2.86 6.398-6.36s-2.891-6.417-6.398-6.417-6.37 2.917-6.37 6.417 2.867 6.36 6.37 6.36m0-16.389A9.99 9.99 0 0 1 150.5 10.028c0 5.555-4.452 9.972-10.015 9.972s-9.985-4.416-9.985-9.972S134.922 0 140.485 0M97.854.417c.028-.222.195-.417.504-.417h.451c.224 0 .392.111.476.277l6.183 13.112h.082L111.734.277c.085-.167.225-.277.476-.277h.452a.47.47 0 0 1 .504.417l3.317 18.667c.082.388-.142.639-.506.639h-2.557c-.254 0-.479-.222-.534-.417l-1.659-10.528h-.085l-4.916 10.916c-.057.168-.224.306-.479.306h-.506c-.252 0-.392-.138-.476-.306L99.792 8.778h-.085l-1.629 10.528c-.03.195-.254.417-.506.417h-2.529c-.364 0-.591-.25-.534-.639L97.854.417zM72.485 16.389c3.505 0 6.399-2.86 6.399-6.36a6.46 6.46 0 0 0-6.399-6.417c-3.504 0-6.369 2.917-6.369 6.417s2.866 6.36 6.369 6.36m0-16.389C78.049 0 82.5 4.472 82.5 10.028S78.049 20 72.485 20 62.5 15.584 62.5 10.028 66.922 0 72.485 0M32.5.499c0-.277.244-.499.514-.499h.678l11.262 12.278h.026V.805c0-.277.216-.528.514-.528h2.491a.54.54 0 0 1 .514.528v18.696c0 .277-.243.499-.514.499h-.65L36.02 7.249h-.027v11.946c0 .277-.216.528-.514.528h-2.465a.54.54 0 0 1-.514-.528V.499zM10.423 0c2.488 0 4.866.973 6.746 2.586.221.222.249.557.028.779l-1.714 1.809c-.222.222-.47.222-.719 0C13.575 4.116 12.11 3.56 10.59 3.56c-3.456 0-6.192 2.977-6.192 6.453 0 3.449 2.736 6.371 6.219 6.371 1.548 0 2.737-.473 3.289-.697v-2.364h-2.211c-.304 0-.525-.222-.525-.5v-2.197a.51.51 0 0 1 .525-.528h5.308c.276 0 .497.249.497.528v7.121c0 .222-.11.362-.221.444 0 0-2.846 1.809-6.856 1.809C4.923 20 .5 15.605.5 10.042S4.923 0 10.423 0" fillRule="evenodd" fill="currentColor" />
          </svg>

          <h1 className='y logo_a' >Alumni</h1>
        </div>


        <div className="alumni_path _f _fm _fgap1 _fwrap">

          {alumniData && <div className="y">
            <RightOutlined />
          </div>}


          <div className="_fm breadcrumb" >
            {items1.map((item, index) => (
              <div key={index} className="_f _fm">
                {item.label}
              </div>
            ))}
          </div>

        </div>

        {/* //TODO: Only active alumni should be able to see this */}
        {/* {page === 'main' && <div className="_f _fr _fm _fwrap _fgrow mobile_v_no">
          <Switch checked={context.state.openToWork} onChange={() => context.state.setOpenToWork(!context.state.openToWork)} /> <span style={{ lineHeight: '1em' }}>Only actively looking for work</span>
        </div>} */}

      </div>

      <Layout>

        <Layout
          style={{
            padding: '24px 0',
          }}
        >


          <Content
            style={{
              minHeight: 280,
              background: colorBgContainer,
              borderRadius: borderRadiusLG,
            }}
          >
            {children}
          </Content>
        </Layout>
      </Layout>
      {/* {page === 'main' && <SubscribeSalesforce />} */}
      {/* {page === 'main' && <Subscribe />} */}
    </Layout>


    <Footer />
  </>
  );
};
